import { unregisterPushToken } from './api';

const PUSH_TOKEN_STORAGE_KEY = 'ip4estates_push_token';

export function rememberToken(token: string): void {
  try {
    localStorage.setItem(PUSH_TOKEN_STORAGE_KEY, token);
  } catch {
    // Non-sensitive cache only; failing to persist should not break push.
  }
}

/**
 * Unregisters the device's push token from the signed-in member's organisation.
 * The stored key is dropped before the request: a 401 here triggers `signOut()`,
 * which would otherwise find the key again and loop.
 */
export async function unregisterStoredToken(): Promise<void> {
  let token: string | null = null;
  try {
    token = localStorage.getItem(PUSH_TOKEN_STORAGE_KEY);
    localStorage.removeItem(PUSH_TOKEN_STORAGE_KEY);
  } catch {
    token = null;
  }

  if (!token) return;

  await unregisterPushToken(token).catch(() => { /* non-fatal */ });
}
